import { Card } from '../../models/card';
import { AppState } from '../index';
import { createSelector } from '@ngrx/store';

export interface ContactEditorState {
    id: string | null;
    reference: string | null;
    addressBookId: string | null;
    card: Card;
    loading: boolean;
    saving: boolean;
}

export const selectContactEditorState = (state: AppState) => state.contactEditor;

export const selectContactEditorCard = createSelector(selectContactEditorState,
    (state: ContactEditorState) => state.card);

export const selectContactEditorAddressBookId = createSelector(selectContactEditorState,
    (state: ContactEditorState) => state.addressBookId);

export const selectContactEditorLoading = createSelector(selectContactEditorState,
    (state: ContactEditorState) => state.loading);

export const selectContactEditorSaving = createSelector(selectContactEditorState,
    (state: ContactEditorState) => state.saving);

export const selectContactEditorId = createSelector(selectContactEditorState,
    (state: ContactEditorState) => state.id);
